import React, { useState } from 'react';
import DocumentacaoComplementarLocal from './documentacaoComplementarLocal';
import DocumentacaoMensal from './documentacaoMensal';
import { Collapse } from 'antd';
import { FormatText, Icon, Widget } from '@digital/ui';

interface DocumentoAcessoariaProps {
  gerirDocumentacaoAcessoria: boolean;
  urlAcessoDocumentacasoAcessorial: string;
}

const AbaDocumentacaoAcessoria = (props: DocumentoAcessoariaProps) => {
  const { Panel } = Collapse;
  const { gerirDocumentacaoAcessoria, urlAcessoDocumentacasoAcessorial } = props;

  const [updaMensagem, setUpdaMensagem] = useState(false);

  const AtualizarGridMensagm = () => {
    setUpdaMensagem(true);
    setUpdaMensagem(false);
  };

  if (gerirDocumentacaoAcessoria) {
    return (
      <>
        <DocumentacaoComplementarLocal onUpdate={AtualizarGridMensagm} atualizar={updaMensagem} />
        <DocumentacaoMensal onUpdate={AtualizarGridMensagm} atualizar={updaMensagem} />
      </>
    );
  } else {
    return (
      <>
        <Collapse
          bordered={false}
          defaultActiveKey={['informativoDocumentacao']}
          expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel key="informativoDocumentacao" header={''} style={{ border: 0 }}>
            <Widget>
              <p>
                {' '}
                A documentação previdenciária e trabalhista deverá ser encaminhada através do link{' '}
                <a href={urlAcessoDocumentacasoAcessorial} target="_blank">
                  {' '}
                  https://www.egot.com.br{' '}
                </a>{' '}
              </p>
              <p />
              <p>
                <div>
                  <b>SERVIÇO DE SUPORTE</b>
                </div>
                <table>
                  <tr>
                    <td>Daniele de Oliveira Martins da Silva</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                    <td>Thiago Souza Porcino</td>
                  </tr>
                  <tr>
                    <td>danieledsilva@deloitte.com</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                    <td>tporcino@deloite.com</td>
                  </tr>
                  <tr>
                    <td>(11) 5186-1000</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                    <td>(11) 5186-1518</td>
                  </tr>
                </table>
              </p>
            </Widget>
          </Panel>
        </Collapse>
      </>
    );
  }
};

export default AbaDocumentacaoAcessoria;
